// {
//   {% for variant in product.variants %}
//     "{{ variant.id }}": {
//       "description": {{ variant.metafields.custom.product_variant_description | metafield_tag | json }},
//       "key_features": {{ variant.metafields.custom.product_variant_key_features | metafield_tag | json }},
//       "special_description": {{ variant.metafields.custom.product_variant_special_description | metafield_tag | json }},
//       "colour": {{ variant.metafields.custom.product_variant_colour | metafield_tag | json }},
//       "vibe": {{ variant.metafields.custom.product_variant_vibe | metafield_tag | json }},
//       "faq": {{ variant.metafields.custom.product_variant_faq | metafield_tag | json }}
//     }{% unless forloop.last %},{% endunless %}
//   {% endfor %}
// }


// window.mainProductData = {
//   description: {{ product.metafields.custom.product_description | metafield_tag | json }},
//   key_features: {{ product.metafields.custom.key_features | metafield_tag | json }},
//   special_description: {{ product.metafields.custom.special_description | metafield_tag | json }},
//   colour: {{ product.metafields.custom.colour | metafield_tag | json }},
//   vibe: {{ product.metafields.custom.vibe | metafield_tag | json }},
//   faq: {{ product.metafields.custom.faq | metafield_tag | json }}
// };


// window.addEventListener('load', () => {
//   const dataTag = document.getElementById('VariantMetafieldData');
//   if (!dataTag || typeof window.mainProductData === 'undefined') return;

//   const variantDataMap = JSON.parse(dataTag.textContent);
//   const fallbackData = window.mainProductData;

//   const productForm = document.querySelector('product-form') || document.querySelector('.product-form-main');
//   if (!productForm) return;

//   const hiddenInput = productForm.querySelector('[name="id"]');
//   if (!hiddenInput) return;

//   let lastVariantId = hiddenInput.value;

//   const containers = {
//     description: document.getElementById('VariantDescriptionContainer'),
//     key_features: document.getElementById('VariantKeyFeaturesContainer'),
//     special_description: document.getElementById('VariantSpecialDescriptionContainer'),
//     colour: document.getElementById('VariantColourContainer'),
//     vibe: document.getElementById('VariantVibeContainer'),
//     faq: document.getElementById('VariantFAQContainer')
//   };

//   function setHTML(el, html) {
//     if (!el) return;
//     el.style.opacity = 0;
//     setTimeout(() => {
//       el.innerHTML = html || '';
//       el.style.opacity = 1;
//     }, 150);
//   }

//   function initFAQAccordion() {
//     const headers = document.querySelectorAll(".accordion-header");
//     headers.forEach(header => {
//       header.addEventListener("click", () => {
//         const item = header.parentElement;
//         const isActive = item.classList.contains("active");
//         document.querySelectorAll(".accordion-item").forEach(el => el.classList.remove("active"));
//         if (!isActive) item.classList.add("active");
//       });
//     });
//   }

//   function updateMetafields() {
//     const variantId = hiddenInput.value;
//     if (!variantId || variantId === lastVariantId) return;
//     lastVariantId = variantId;

//     const vData = variantDataMap[variantId] || {};

//     setHTML(containers.description, vData.description || fallbackData.description);
//     setHTML(containers.key_features, vData.key_features || fallbackData.key_features);
//     setHTML(containers.special_description, vData.special_description || fallbackData.special_description);
//     setHTML(containers.colour, vData.colour || fallbackData.colour);
//     setHTML(containers.vibe, vData.vibe || fallbackData.vibe);
//     setHTML(containers.faq, vData.faq || fallbackData.faq);

//     // Re-init accordion after content reload
//     setTimeout(initFAQAccordion, 200);
//   }

//   const observer = new MutationObserver(updateMetafields);
//   observer.observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });

//   hiddenInput.addEventListener('change', updateMetafields);
//   hiddenInput.addEventListener('input', updateMetafields);

//   initFAQAccordion();
//   console.log('✅ Variant metafield updater initialized.');
// });



/////////////////////////////////////////////////WORKING
// window.addEventListener('load', () => { 
//   const keyFeaturesContainer = document.getElementById('KeyFeaturesContainer');
//   const dataTag = document.getElementById('KeyFeatureVariantMetafieldData');
  
//   if (!keyFeaturesContainer || !dataTag) return;

//   try {
//     const data = JSON.parse(dataTag.textContent);
//     const variantDataMap = data.variants;
//     const fallbackData = data.fallback;

//     // --- Find and validate hidden input ---
//     const hiddenInputContainer = document.querySelector('product-form') || 
//                                  document.querySelector('.product-form-main') ||
//                                  document.querySelector('variant-picker');
    
//     if (!hiddenInputContainer) return;

//     const hiddenInput = hiddenInputContainer.querySelector('[name="id"]');
//     if (!hiddenInput) return;

//     let lastVariantId = hiddenInput.value;

//     // --- Helper function to render Key Features List ---
//     function renderKeyFeatures(featuresArray) {
//         if (!featuresArray || featuresArray.length === 0) {
//             return ''; // Return an empty string if no features
//         }
//         let html = '<ul class="key-feature-list">';
//         featuresArray.forEach(feature => {
//             html += `<li>${feature}</li>`;
//         });
//         html += '</ul>';
//         return html;
//     }

//     // --- Main Update Function ---
//     function updateVariantContent() {
//       const selectedVariantId = hiddenInput.value;
//       if (!selectedVariantId || selectedVariantId === lastVariantId) return;

//       lastVariantId = selectedVariantId;

//       // Get the data for the selected variant, falling back to product-level data
//       const variantData = variantDataMap[selectedVariantId];
      
//       // Determine the features to use (variant-specific or fallback)
//       const features = (variantData.key_features && variantData.key_features.length > 0) 
//           ? variantData.key_features 
//           : fallbackData.key_features;

//       // 1. Update Key Features
//       const newContent = renderKeyFeatures(features);
      
//       // Optional: Smooth transition
//       keyFeaturesContainer.style.opacity = 0;
//       setTimeout(() => {
//           keyFeaturesContainer.innerHTML = newContent;
//           keyFeaturesContainer.style.opacity = 1;
//       }, 150);
//     }

//     // ✅ MutationObserver — detects when the hidden variant ID input value changes
//     const observer = new MutationObserver(updateVariantContent);
//     observer.observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });

//     console.log('Key Features variant content watcher initialized.');

//   } catch (error) {
//     console.error('Error initializing variant content updater:', error);
//   }
// });

// window.addEventListener('load', () => {
//   const container = document.getElementById('VariantDescriptionContainer');
//   const dataTag = document.getElementById('VariantMetafieldData');
  
//   if (!container || !dataTag || typeof window.mainProductDescription === 'undefined') return;

//   try {
//     const variantDataMap = JSON.parse(dataTag.textContent);
//     const fallbackDescription = window.mainProductDescription;

//     const productForm = document.querySelector('product-form') || document.querySelector('.product-form-main');
//     if (!productForm) {
//       console.error('Product form element not found for variant update listener.');
//       return;
//     }

//     // Get current selected variant ID
//     const hiddenInput = productForm.querySelector('[name="id"]');
//     if (!hiddenInput) {
//       console.error('Hidden input [name="id"] not found.');
//       return;
//     }

//     let lastVariantId = hiddenInput.value;

//     function updateVariantDescription() {
//       const selectedVariantId = hiddenInput.value;
//       if (!selectedVariantId || selectedVariantId === lastVariantId) return;

//       lastVariantId = selectedVariantId;

//       const variantInfo = variantDataMap[selectedVariantId];
//       let newDescriptionHTML = '';

//       if (variantInfo && variantInfo.variant_description && variantInfo.variant_description !== 'null') {
//         newDescriptionHTML = variantInfo.variant_description;
//       } else {
//         newDescriptionHTML = fallbackDescription;
//       }

//       // Optional: Smooth transition
//       container.style.opacity = 0;
//       setTimeout(() => {
//         container.innerHTML = newDescriptionHTML;
//         container.style.opacity = 1;
//       }, 150);
//     }

//     // ✅ Use MutationObserver — detects variant input value changes dynamically
//     const observer = new MutationObserver(updateVariantDescription);
//     observer.observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });

//     // As fallback — also listen to change/input events
//     hiddenInput.addEventListener('change', updateVariantDescription);
//     hiddenInput.addEventListener('input', updateVariantDescription);

//     console.log('Variant description watcher initialized.');

//   } catch (error) {
//     console.error('Error initializing variant description updater:', error);
//   }
// });

// window.addEventListener('load', () => { 
//     const specialDescriptionContainer = document.getElementById('SpecialDescriptionContainer');
//     const dataTag = document.getElementById('SpecialDescVariantMetafieldData'); // Ensure this ID is correct
//     console.log(specialDescriptionContainer);
//     if (!specialDescriptionContainer || !dataTag) return;

//     try {
//         const data = JSON.parse(dataTag.textContent);
//         const variantDataMap = data.variants;
//         const fallbackData = data.fallback;

//         // Find the common hidden input
//         const hiddenInputContainer = document.querySelector('product-form') || 
//                                      document.querySelector('.product-form-main') ||
//                                      document.querySelector('variant-picker');
        
//         if (!hiddenInputContainer) return;
//         const hiddenInput = hiddenInputContainer.querySelector('[name="id"]');
//         if (!hiddenInput) return;

//         let lastVariantId = hiddenInput.value;

//         function updateSpecialDescriptionContent() {
//             const selectedVariantId = hiddenInput.value;
//             if (!selectedVariantId || selectedVariantId === lastVariantId) return;

//             lastVariantId = selectedVariantId;

//             const variantData = variantDataMap[selectedVariantId] || {};

//             // --- SPECIAL DESCRIPTION LOGIC ---
//             const specialDescription = (variantData.special_description && variantData.special_description !== 'null')
//                 ? variantData.special_description
//                 : fallbackData.special_description;

//             // Apply update with optional smooth transition
//             specialDescriptionContainer.style.opacity = 0;
//             setTimeout(() => {
//                 specialDescriptionContainer.innerHTML = specialDescription;
//                 specialDescriptionContainer.style.opacity = 1;
//             }, 150);
//         }

//         // MutationObserver — detects when the hidden variant ID input value changes
//         const observer = new MutationObserver(updateSpecialDescriptionContent);
//         observer.observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });

//         console.log('Special Description variant content watcher initialized.');

//     } catch (error) {
//         console.error('Error initializing Special Description updater:', error);
//     }
// });

// window.addEventListener('load', () => { 
//   // --- Element Selectors ---
//   const dataTag = document.getElementById('UnifiedVariantMetafieldData'); // Use your actual unified data ID
//   const colourTextContainer = document.getElementById('ColourTextContainer');
  
//   if (!colourTextContainer || !dataTag) return;

//   try {
//     const data = JSON.parse(dataTag.textContent);
//     const variantDataMap = data.variants;
//     const fallbackData = data.fallback;

//     // --- Find and validate hidden input (Crucial for the MutationObserver) ---
//     const hiddenInputContainer = document.querySelector('product-form') || 
//                                  document.querySelector('.product-form-main') ||
//                                  document.querySelector('variant-picker');
    
//     if (!hiddenInputContainer) return;

//     const hiddenInput = hiddenInputContainer.querySelector('[name="id"]');
//     if (!hiddenInput) return;

//     let lastVariantId = hiddenInput.value;

//     // --- Main Update Function ---
//     function updateColourContent() {
//       const selectedVariantId = hiddenInput.value;
//       if (!selectedVariantId || selectedVariantId === lastVariantId) return;

//       lastVariantId = selectedVariantId;

//       // Safely retrieve variant data, falling back to an empty object if ID is not found
//       const variantData = variantDataMap[selectedVariantId] || {};

//       // Data Determination
//       const colour = (variantData.colour && variantData.colour !== 'null') 
//           ? variantData.colour 
//           : fallbackData.colour;

//       // Apply update
//       colourTextContainer.style.opacity = 0;
//       setTimeout(() => {
//           colourTextContainer.innerHTML = colour;
//           colourTextContainer.style.opacity = 1;
//       }, 150);
//     }

//     // MutationObserver — detects when the hidden variant ID input value changes
//     const observer = new MutationObserver(updateColourContent);
//     observer.observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });

//     console.log('Colour variant content watcher initialized.');

//   } catch (error) {
//     console.error('Error initializing Colour updater:', error);
//   }
// });

// window.addEventListener('load', () => { 
//   // --- Element Selectors ---
//   const dataTag = document.getElementById('UnifiedVariantMetafieldData'); // Use your actual unified data ID
//   const vibeContainer = document.getElementById('VibeContainer'); // TARGET VIBE CONTAINER
  
//   if (!vibeContainer || !dataTag) return;

//   try {
//     const data = JSON.parse(dataTag.textContent);
//     const variantDataMap = data.variants;
//     const fallbackData = data.fallback;

//     // --- Find and validate hidden input (Crucial for the MutationObserver) ---
//     const hiddenInputContainer = document.querySelector('product-form') || 
//                                  document.querySelector('.product-form-main') ||
//                                  document.querySelector('variant-picker');
    
//     if (!hiddenInputContainer) return;

//     const hiddenInput = hiddenInputContainer.querySelector('[name="id"]');
//     if (!hiddenInput) return;

//     let lastVariantId = hiddenInput.value;

//     // --- Helper function to render the Vibe list ---
//     function renderVibeList(listArray) {
//         if (!listArray || listArray.length === 0) return '';
//         let html = '<ul class="vibe-list">';
//         listArray.forEach(item => { html += `<li>${item}</li>`; });
//         html += '</ul>';
//         return html;
//     }

//     // --- Main Update Function ---
//     function updateVibeContent() {
//       const selectedVariantId = hiddenInput.value;
//       if (!selectedVariantId || selectedVariantId === lastVariantId) return;

//       lastVariantId = selectedVariantId;

//       // Safely retrieve variant data, falling back to an empty object if ID is not found
//       const variantData = variantDataMap[selectedVariantId] || {};

//       // Data Determination for Vibe
//       // Vibe is a list type, so we look for array data
//       const vibeList = (variantData.vibe && variantData.vibe.length > 0) 
//           ? variantData.vibe 
//           : fallbackData.vibe;

//       const newContent = renderVibeList(vibeList);

//       // Apply update
//       vibeContainer.style.opacity = 0;
//       setTimeout(() => {
//           vibeContainer.innerHTML = newContent;
//           vibeContainer.style.opacity = 1;
//       }, 150);
//     }

//     // MutationObserver — detects when the hidden variant ID input value changes
//     const observer = new MutationObserver(updateVibeContent); // Use the Vibe function here
//     observer.observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });

//     console.log('Vibe variant content watcher initialized.');

//   } catch (error) {
//     console.error('Error initializing Vibe updater:', error);
//   }
// });

// window.addEventListener('load', () => { 
//   // --- Element Selectors ---
//   const dataTag = document.getElementById('FAQVariantMetafieldData'); // Use your actual unified data ID
//   const faqWrapper = document.getElementById('FAQAccordionWrapper');
  
//   if (!faqWrapper || !dataTag) return;

//   try {
//     const data = JSON.parse(dataTag.textContent);
//     const variantDataMap = data.variants;
//     const fallbackData = data.fallback;

//     // --- Find and validate hidden input ---
//     const hiddenInputContainer = document.querySelector('product-form') || 
//                                  document.querySelector('.product-form-main') ||
//                                  document.querySelector('variant-picker');
    
//     if (!hiddenInputContainer) return;
//     const hiddenInput = hiddenInputContainer.querySelector('[name="id"]');
//     if (!hiddenInput) return;

//     let lastVariantId = hiddenInput.value;

//     // --- Helper function to render Rich Text JSON to HTML ---
//     function parseRichTextToHtml(richTextJson) {
//         if (!richTextJson || typeof richTextJson !== 'object' || richTextJson.type !== 'root') {
//             return '';
//         }
      
//         let html = '';

//         // Simple parser: Iterates through top-level children (like paragraphs)
//         richTextJson.children.forEach(child => {
//             if (child.type === 'paragraph') {
//                 let paragraphContent = '';

//                 // Collects text value from nested text children
//                 child.children.forEach(grandchild => {
//                     if (grandchild.type === 'text') {
//                         // Replace \\n\\n with <br><br> for line breaks
//                         paragraphContent += grandchild.value.replace(/\\n\\n/g, '<br><br>'); 
//                     }
//                 });
//                 // Wrap in a paragraph tag
//                 html += `<p>${paragraphContent}</p>`;
//             }
//             // You would need to add logic here for other types (e.g., 'list', 'heading', 'image') 
//             // if your rich text content uses them.
//         });
      
//         return html;
//     }

//     // --- Helper function to render FAQ Accordion HTML (UPDATED) ---
//     function renderFAQAccordion(faqList) {
//         if (!faqList || faqList.length === 0) {
//             return '<p>No FAQs found.</p>';
//         }
//         let html = '';
//         faqList.forEach(item => {
//             const title = item.faq_title.value || '';
//             const rawContent = item.faq_content; 
            
//             // 1. Convert the raw content string back to a JS object
//             let contentObject = {};
//             try {
//                 contentObject = JSON.parse(rawContent);
//             } catch (e) {
//                 console.error('Failed to parse FAQ rich text JSON:', e);
//                 // Fallback to raw text if parsing fails
//                 contentObject = { type: 'root', children: [{ type: 'paragraph', children: [{ type: 'text', value: rawContent || '' }] }] };
//             }
            
//             // 2. Parse the JS object into proper HTML
//             const contentHtml = parseRichTextToHtml(contentObject);
            
//             html += `
//                 <div class="accordion-item">
//                     <button type="button" class="accordion-header">
//                         ${title}
//                         <span class="icon">+</span>
//                     </button>
//                     <div class="accordion-content">
//                         ${contentHtml}
//                     </div>
//                 </div>
//             `;
//         });
//         return html;
//     }
    
//     // --- Helper function to re-initialize accordion behavior ---
//     function initializeFAQAccordion(wrapperElement) {
//         const headers = wrapperElement.querySelectorAll(".accordion-header");
//         headers.forEach((header) => {
//             header.addEventListener("click", () => {
//                 const item = header.parentElement;
//                 const isActive = item.classList.contains("active");

//                 // Close all others
//                 wrapperElement.querySelectorAll(".accordion-item")
//                     .forEach((el) => el.classList.remove("active"));

//                 // Open this one
//                 if (!isActive) {
//                     item.classList.add("active");
//                 }
//             });
//         });
//     }


//     // --- Main Update Function ---
//     function updateFAQContent() {
//       const selectedVariantId = hiddenInput.value;
//       if (!selectedVariantId || selectedVariantId === lastVariantId) return;

//       lastVariantId = selectedVariantId;

//       const variantData = variantDataMap[selectedVariantId] || {};

//       // Data Determination
//       const faqList = (variantData.faq.raw && variantData.faq.raw.length > 0) 
//           ? variantData.faq.raw 
//           : fallbackData.faq.raw;

//       // 1. Render new HTML
//       faqWrapper.innerHTML = renderFAQAccordion(faqList);
      
//       // 2. IMPORTANT: Re-initialize the JS functionality for the new HTML
//       initializeFAQAccordion(faqWrapper);
//     }

//     // MutationObserver — detects when the hidden variant ID input value changes
//     const observer = new MutationObserver(updateFAQContent);
//     observer.observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });

//     // IMPORTANT: Initialize the accordion behavior on initial page load as well
//     initializeFAQAccordion(faqWrapper);

//     console.log('FAQ variant content watcher initialized.');

//   } catch (error) {
//     console.error('Error initializing FAQ updater:', error);
//   }
// });

window.addEventListener('load', () => { 
  // --- Element Selectors & Data Map ---
  const dataTag = document.getElementById('UnifiedVariantMetafieldData'); 
  
  if (!dataTag) return;

  try {
    const data = JSON.parse(dataTag.textContent);
    const variantDataMap = data.variants;
    const fallbackData = data.fallback;

    // Content containers (Select ALL containers needed for dynamic update)
    // NOTE: Ensure these IDs match your theme's HTML structure
    const keyFeaturesContainer = document.getElementById('KeyFeaturesContainer');
    const specialDescriptionContainer = document.getElementById('SpecialDescriptionContainer');
    const colourTextContainer = document.getElementById('ColourTextContainer');
    const vibeContainer = document.getElementById('VibeContainer'); // The container that wasn't updating
    const faqWrapper = document.getElementById('FAQAccordionWrapper');

    // --- Find and validate hidden input (Crucial for the MutationObserver) ---
    const hiddenInputContainer = document.querySelector('product-form') || 
                                 document.querySelector('.product-form-main') ||
                                 document.querySelector('variant-picker');
    
    if (!hiddenInputContainer) return;

    const hiddenInput = hiddenInputContainer.querySelector('[name="id"]');
    if (!hiddenInput) return;

    let lastVariantId = hiddenInput.value;
    
    // --- Helper 1: Renders simple array list (Used for Key Features) ---
    function renderList(listArray, listClass) {
        if (!listArray || listArray.length === 0) return '';
        // IMPORTANT: Ensure listArray is an actual array before using forEach
        if (!Array.isArray(listArray)) return ''; 

        let html = `<ul class="${listClass}">`;
        listArray.forEach(item => { html += `<li>${item}</li>`; });
        html += '</ul>';
        return html;
    }
    
    // --- Helper 2: Renders Rich Text JSON to HTML (Used for FAQ content) ---
    function parseRichTextToHtml(richTextJson) {
        if (!richTextJson || typeof richTextJson !== 'object' || richTextJson.type !== 'root') {
            return '';
        }

        let html = '';
        
        richTextJson.children.forEach(child => {
            if (child.type === 'paragraph') {
                let paragraphContent = '';
                
                if (child.children) {
                    child.children.forEach(item => {
                        if (item.type === 'text' && typeof item.value === 'string') {
                            paragraphContent += item.value.replace(/\\n\\n/g, '<br><br>'); 
                        }
                    });
                }
                html += `<p>${paragraphContent}</p>`;
            }
        });
        return html;
    }

    // --- Helper 3: Renders FAQ Accordion HTML ---
    function renderFAQAccordion(faqList) {
        if (!faqList || faqList.length === 0) {
            return '<p>No FAQs found.</p>';
        }
        let html = '';
        faqList.forEach(item => {
            // FAQ titles are simple strings/values from the metaobject array structure
            const title = item.faq_title.value || item.faq_title || '';
            let contentData = item.faq_content; 
            
            let contentObject;
            // Handle the fact that contentData might be a JSON string or already a JS object
            if (typeof contentData === 'string') {
                 try {
                    contentObject = JSON.parse(contentData);
                 } catch (e) {
                    contentObject = { type: 'root', children: [{ type: 'paragraph', children: [{ type: 'text', value: contentData || '' }] }] };
                 }
            } else if (typeof contentData === 'object' && contentData !== null) {
                contentObject = contentData; 
            } else {
                return;
            }
            
            const contentHtml = parseRichTextToHtml(contentObject);
            
            html += `
                <div class="accordion-item">
                    <button type="button" class="accordion-header">
                        ${title}
                        <span class="icon">+</span>
                    </button>
                    <div class="accordion-content">
                        ${contentHtml}
                    </div>
                </div>
            `;
        });
        return html;
    }
    
    // --- Helper 4: Re-initializes Accordion behavior ---
    function initializeFAQAccordion(wrapperElement) {
        const headers = wrapperElement.querySelectorAll(".accordion-header");
        headers.forEach((header) => {
            header.addEventListener("click", () => {
                const item = header.parentElement;
                const isActive = item.classList.contains("active");

                wrapperElement.querySelectorAll(".accordion-item")
                    .forEach((el) => el.classList.remove("active"));

                if (!isActive) {
                    item.classList.add("active");
                }
            });
        });
    }

    // --- Main Update Function (UNIFIED and FIXED) ---
    function updateVariantContent() {
      const selectedVariantId = hiddenInput.value;
      if (!selectedVariantId || selectedVariantId === lastVariantId) return;

      lastVariantId = selectedVariantId;

      const variantData = variantDataMap[selectedVariantId] || {};

      // 1. Data Determination
      const features = (variantData.key_features && variantData.key_features.length > 0) ? variantData.key_features : fallbackData.key_features;
      const specialDesc = (variantData.special_description && variantData.special_description !== 'null') ? variantData.special_description : fallbackData.special_description;
      const colour = (variantData.colour && variantData.colour !== 'null') ? variantData.colour : fallbackData.colour;
      
      // *** FIX FOR VIBE: Treat as already-rendered HTML string ***
      const vibeHTML = (variantData.vibe && variantData.vibe !== 'null') ? variantData.vibe : fallbackData.vibe; 
      
      const faqList = (variantData.faq && variantData.faq.raw && variantData.faq.raw.length > 0) ? variantData.faq.raw : (fallbackData.faq ? fallbackData.faq.raw : []);


      // Helper for applying transition
      const applyTransition = (container, contentHTML) => {
        if (container) {
            container.style.opacity = 0;
            setTimeout(() => {
                container.innerHTML = contentHTML || '';
                container.style.opacity = 1;
            }, 150);
        }
      };

      // 2. Apply Updates
      
      // Key Features (List/Array that needs rendering)
      applyTransition(keyFeaturesContainer, renderList(features, 'key-feature-list'));
      
      // Special Description (Plain HTML String)
      applyTransition(specialDescriptionContainer, specialDesc);
      
      // Colour (Plain HTML String)
      applyTransition(colourTextContainer, colour);
      
      // Vibe (FIXED: Plain HTML String from metafield_tag)
      applyTransition(vibeContainer, renderList(vibeHTML, 'key-feature-list'));
      
      // FAQ (Special handling: requires direct HTML update and re-initialization)
      if (faqWrapper) {
          faqWrapper.innerHTML = renderFAQAccordion(faqList);
          initializeFAQAccordion(faqWrapper);
      }
    }

    // MutationObserver — detects when the hidden variant ID input value changes
    const observer = new MutationObserver(updateVariantContent);
    observer.observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });

    // Initialize FAQ accordion behavior on page load
    if (faqWrapper) {
        initializeFAQAccordion(faqWrapper);
    }
    
    console.log('All unified variant content watchers initialized. Vibe fix included. ✅');

  } catch (error) {
    console.error('Error initializing unified variant content updater. Check your Liquid JSON structure:', error);
  }
});